module.exports = __webpack_public_path__ + "img/icon_omnichannel_integracao.595570ae.svg";